module.exports = __webpack_public_path__ + "img/rochford.23279779.jpg";